import find from 'lodash/find'

export function getProductTitles(ids, products) {
    return products
        .filter((p) => ids.includes(p.id))
        .map((p) => p.title)
        .join(', ')
}

export function getProductsFromIds(ids, products) {
    if (!ids || !products) return []
    if (products.length < 1 || ids.length < 1) return []
    let result = []
    ids.forEach((id) => {
        const product = find(products, (p) => p.id === id)
        if (product) {
            result.push(product)
        }
    })
    return result
}
